import type { PlatformStaff } from '@/types/platformStaff'
import { platformStaffFixture } from '@/fixtures/platformStaff.fixture'
import { simulateLatency } from '@/services/mock/latency'
import { httpClient, setAuthToken } from '@/services/http/httpClient'
import { pickService } from '@/services/http/apiMode'

export interface PlatformAuthService {
  login(email: string, _password: string): Promise<PlatformStaff>
  logout(): Promise<void>
}

const mockPlatformAuthService: PlatformAuthService = {
  async login(email) {
    await simulateLatency()
    const staff = platformStaffFixture.find((s) => s.email.toLowerCase() === email.trim().toLowerCase())
    if (!staff) {
      throw {
        code: 'invalid_credentials',
        message: 'Email sau parolă incorecte.',
        fieldErrors: { email: 'Nu găsim un cont EReach cu acest email.' },
      }
    }
    return staff
  },
  async logout() {
    await simulateLatency(100, 250)
  },
}

const httpPlatformAuthService: PlatformAuthService = {
  async login(email, password) {
    const { token, staff } = await httpClient.post<{ token: string; staff: PlatformStaff }>('/platform/auth/login', { email, password })
    setAuthToken(token, true, 'platform')
    return staff
  },
  async logout() {
    try {
      await httpClient.post('/platform/auth/logout')
    } finally {
      setAuthToken(null, true, 'platform')
    }
  },
}

export const platformAuthService: PlatformAuthService = pickService(mockPlatformAuthService, httpPlatformAuthService)
